import { Box, Typography } from '@mui/material';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Container } from "react-bootstrap";
import BottomNavBar from '../components/BottomNavBar';
import { setMobileBackColor, setMobileCardBorderColor, setMobileTextColor } from '../utility';
import { t } from 'i18next';
import DOMPurify from 'dompurify';

const PrivacyPolicy = ({ tableQr, tableName }) => {
    const [menuTree, setMenuTree] = useState(JSON.parse(localStorage.getItem("tree_data")) || []);
    const [loadingTreeDialog, setLoadingTreeDialog] = useState(false);
    const [loadingTree, setLoadingTree] = useState(false);
    const location = useLocation();

    const loadTree = async () => {
        setLoadingTree(true);
        try {
            const timeZone = localStorage.getItem("timezone") || "";
            const promise = await axios.get(
                `${process.env.REACT_APP_API}/menus/${tableQr}/public-tree`,
                {
                    headers: {
                        localization: localStorage.getItem("lang") || "",
                        timeZone: timeZone.replace(/["]+/g, ''),
                    },
                }
            );

            if (promise?.data?.data?.length === 0 || !promise?.data?.data?.details || !promise?.data?.data?.tree || !promise?.data?.data?.items) {
                setLoadingTreeDialog(true);
            }
            setMenuTree(promise?.data?.data || []);
            localStorage.setItem(
                "tree_data",
                JSON.stringify(promise?.data?.data ? promise?.data?.data : [])
            );

            return promise?.data?.data;
        } catch (error) {
            // Handle error
        } finally {
            setLoadingTree(false);
        }
    };

    const loadTreeData = async () => {
        if (menuTree.length === 0 || !menuTree.details || !menuTree.tree || !menuTree.items) {
            loadTree();
        } else {
            const pathname = location.pathname;
            const pathSegments = pathname.split("/");
            const menu_code_number = pathSegments[2];
            const treeMenu_code_number = menuTree?.details?.code_number;
            if (menu_code_number !== treeMenu_code_number) {
                loadTree();
            }
        }
    };

    const createSanitizedHTML = (html) => {
        return {
            __html: DOMPurify.sanitize(html || '')
        };
    };

    useEffect(() => {
        loadTreeData();
    }, []);

    return (
        <div className={`min-vh-100`} style={{ backgroundColor: setMobileBackColor() }}>
            <Container>
                {/* Professional Header Section */}
                <Box sx={{
                    py:1,
                    borderBottom: '1px solid',
                    borderColor: setMobileCardBorderColor(),
                    textAlign: 'center'
                }}>
                    <Typography
                        variant="h5"
                        component="h1"
                        sx={{
                            fontWeight: 'bold',
                            mb: 1,
                            color: setMobileTextColor()
                        }}
                    >
                        {t('Privacy Policy')}
                    </Typography>

                </Box>

                {/* Main Content Area */}
                <Box sx={{
                    maxWidth: '800px',
                    mx: 'auto'
                }}>
                    {loadingTree ? (
                        <Box sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}>
                            <Typography variant="body1">
                                Loading privacy policy...
                            </Typography>
                        </Box>
                    ) : menuTree?.details?.privacy_policy ? (
                        <Box
                            className="privacy-policy-content"
                            dangerouslySetInnerHTML={createSanitizedHTML(menuTree.details.privacy_policy)}
                            sx={{
                                lineHeight: 1.8,
                                '& h2': {
                                    fontSize: '1.5rem',
                                    fontWeight: 'bold',
                                    mt: 4,
                                    mb: 2,
                                    color: setMobileTextColor()
                                },
                                '& h3': {
                                    fontSize: '1.25rem',
                                    fontWeight: 'bold',
                                    mt: 3,
                                    mb: 1.5
                                },
                                '& p': {
                                    mb: 2,
                                    color: setMobileTextColor()
                                },
                                '& ul, & ol': {
                                    pl: 3,
                                    mb: 2,
                                    '& li': {
                                        mb: 1
                                    }
                                },
                                '& a': {
                                    color: 'primary.main',
                                    textDecoration: 'none',
                                    '&:hover': {
                                        textDecoration: 'underline'
                                    }
                                },
                                '& strong': {
                                    fontWeight: 'bold'
                                }
                            }}
                        />
                    ) : (
                        <Box sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '200px'
                        }}>
                            <Typography variant="body1">
                                No privacy policy available.
                            </Typography>
                        </Box>
                    )}
                </Box>
            </Container>
            <BottomNavBar qr={tableQr} qrName={tableName} />
        </div>
    );
}

export default PrivacyPolicy;